import React from "react";
import Footer from "../Components/Footer/footer";
import Header from "../Components/Header/header";
import HotBar from "../Components/HotBar/hotBar";
import Shop from "../Components/Shop/shop";

function ShopPage() {
  return (
    <>
      <Header />
      <HotBar />
      <Shop />
      <Footer />
    </>
  );
}

export default ShopPage;
